import news from './fragment-news-item'
import link from './fragment-link'
import seo from './fragment-seo'

export default /* graphql */ `
query($preview: Boolean, $slug: String) {
  newsCollection(preview: $preview, limit: 1, where:{slug: $slug}) {
	  items {
      ...news
	  }
    total
  }
}

${news}
${link}
${seo}
`
